<div class="container text-center pt-5">
  <div class="bg-primary border border-secondary rounded p-3">
    <div class="mb-4 text-white">{{ 'card.linking.processing.message' | translate }}</div>
    <fgbcl-loading></fgbcl-loading>
  </div>
</div>
